import * as actions from './actions';
import mutations from './mutations';
import * as getters from './getters';

const state = {
    status: '',
    token: localStorage.getItem('token') || '',
};

export default {
    namespaced: true,
    mutations,
    actions,
    state,
    getters,
};
